import Cookies from 'js-cookie';

export { Cookies };
